import { FEATURE_FLAG, OnboardingFlowV3 } from "@blacknut/javascript-sdk/dist";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { PreshippingId } from "core/utils";
import {
  dismissOnboardingFlowLoadError,
  getSubscriptionFlowV3,
} from "../../redux/actions/App";
import { m1GenerateToken } from "../../redux/actions/M1";
import { dismissAuthenticationError } from "../../redux/actions/User";
import { State } from "../../redux/reducers";
import { usePrevious } from "../../utils/Hooks";
import { onUserSignupSuccessV3 } from "../../utils/OnboardingUtils";
import { RouteNames, WithRouterProps } from "../../utils/WithRouter";
/**@deprecated */
export const useOnboardingV3 = (
  props: {
    preId?: PreshippingId;
  } & WithRouterProps<unknown>,
) => {
  const dispatch = useDispatch();
  const { preId } = props;
  const {
    user,
    preshippingId,
    onboardingFlow,
    googleSignin,
    signingUp,
    config,
    billingInfo,
    authentication,
    organization,
  } = useSelector((state: State) => state.globalState);
  const finalPreshippingId = preId || preshippingId;

  const featureFlags = config?.features || {};
  const allowNoSubscription =
    featureFlags[FEATURE_FLAG.ALLOW_NAVIGATION_SUBSCRIPTION_KO];

  const previousSignup = usePrevious(signingUp);
  React.useEffect(() => {
    console.log("in use effect", user, signingUp.inProgress);
    if (previousSignup?.inProgress && !signingUp.inProgress && !signingUp.error) {
      if (user && onboardingFlow.flow) {
        onUserSignupSuccessV3({
          flow: onboardingFlow.flow as OnboardingFlowV3,
          navigate: props.navigate,
          user,
          billingInfo,
          allowNoSubscription,
          preshippingId: finalPreshippingId,
        });
      }
    }
  }, [
    allowNoSubscription,
    billingInfo,
    finalPreshippingId,
    onboardingFlow.flow,
    previousSignup?.inProgress,
    props.navigate,
    signingUp,
    user,
  ]);

  const previousAuth = usePrevious(authentication);
  React.useEffect(() => {
    if (
      previousAuth?.inProgress &&
      !authentication.inProgress &&
      !authentication.error
    ) {
      if (user && onboardingFlow.flow) {
        onUserSignupSuccessV3({
          flow: onboardingFlow.flow as OnboardingFlowV3,
          navigate: props.navigate,
          user,
          billingInfo,
          allowNoSubscription,
          preshippingId: finalPreshippingId,
        });
      } else {
        props.navigate({
          name: RouteNames.SELECT_PROFILE,
          clearHistory: true,
          fromRegister: true,
        });
      }
    }
  }, [
    allowNoSubscription,
    authentication,
    billingInfo,
    finalPreshippingId,
    onboardingFlow.flow,
    previousAuth?.inProgress,
    props,
    user,
  ]);

  React.useEffect(() => {
    if (
      !onboardingFlow.flow &&
      !onboardingFlow.loading &&
      !onboardingFlow.loadingError
    ) {
      getSubscriptionFlowV3(finalPreshippingId)(dispatch);
    }
  }, [dispatch, finalPreshippingId, onboardingFlow]);

  return {
    flow: onboardingFlow.flow as OnboardingFlowV3 | undefined,
    loading: onboardingFlow.loading,
    loadError: onboardingFlow.loadingError,
    googleApiKey: googleSignin,
    authenticating: authentication.inProgress,
    authenticationError: authentication.error,
    organization,
    dismissLoadError: React.useCallback(() => {
      dismissOnboardingFlowLoadError()(dispatch);
    }, [dispatch]),
    dismissAuthenticationError: React.useCallback(() => {
      dismissAuthenticationError()(dispatch);
    }, [dispatch]),

    m1GenerateToken: React.useCallback(() => {
      m1GenerateToken()(dispatch);
    }, [dispatch]),
  };
};
